"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactDom = _interopRequireDefault(require("react-dom"));
var _react = _interopRequireWildcard(require("react"));
var _ModalContent = _interopRequireDefault(require("Modals/ModalComponent/ModalContent"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class Modal extends _react.Component {
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const output = /*#__PURE__*/_react.default.createElement(_react.Fragment, null, props.open === true ? /*#__PURE__*/_react.default.createElement(_ModalContent.default, props, props.children) : undefined);
    return /*#__PURE__*/_reactDom.default.createPortal(output, document.body);
  }
}
exports.default = Modal;
